// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__38s7e","insightsList":"newBusinessInsightsMenu_insightsList__1gAqM","active":"newBusinessInsightsMenu_active__3wdP6"};